import { Button } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLangStore } from 'store/authAtom'

const NotFound = () => {
    const { t } = useTranslation()
    const lang = useLangStore((state) => state.lang)
    return (
        <div className={`${lang === 'en_US' ? 'font-kt-en' : 'font-kt-zh'}`}>
            <div className='mx-auto text-secondary-midnightBlue  '>
                <div className='pb-4 text-[28px] font-[600]'>{t('errorPage.title')}</div>
                <div className='text-[16px]'>{t('errorPage.about')}</div>
                <div className='text-center'>
                    <Button
                        onClick={() => (window.location.href = `${process.env.REACT_APP_WEBSITE}?lang=${lang}`)}
                        className='border-[1px] mt-8 text-lg leading-8 px-5 h-fit py-[7px] w-[342px]'
                        variant='secondary'
                        style={{ borderRadius: '100px' }}
                    >
                        <div
                            className={`${lang === 'en_US' ? 'font-kt-en' : 'font-kt-zh'} text-[18px] font-[600]`}
                            style={{ textTransform: 'none' }}
                        >
                            {t('errorPage.btn')}
                        </div>
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default NotFound
